import { Api } from '@fnv-core/http';
import { IApiOptions } from '@fnv-core/http/interfaces';
import { addQueryParameters, IQueryParam } from '@fnv-core/utils';
import { ILocationFinderItem } from './interfaces';

export class RegionalService {
  private static baseApiUrl = '/api';
  private static defaultApiOptions: IApiOptions = { cache: true };

  // returns regional offices
  public static async getLocations(address: string) {

    let url = `${this.baseApiUrl}/regiokantoor/nearbyunionhousesbyaddress`;

    const queryParams: IQueryParam[] = [];
    queryParams.push({ key: 'address', value: address.trim().toLowerCase() });
    url = addQueryParameters(url, queryParams);

    try {
      const result = await Api.get<ILocationFinderItem[]>(
        url,
        this.defaultApiOptions
      );

      return result;
    } catch (ex) {
      console.error(ex);
      return [];
    }
  }
}